module.exports = __webpack_public_path__ + "img/SISGEOMOVSALA10.a294e4a4.svg";